import React from "react";
import { Container, Col, Row } from "react-bootstrap";

export const Footer: React.FC = () => {
  return (
    <div className="footer">
      <Container>
        <Row>
          <Col>
            <div className="footer__wrapper">
              <span className="footer__copy">&copy; 2023 Meine Uniklinik</span>
              <div className="footer__links">
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href="https://www.uniklinik-freiburg.de/footernavigation/impressum.html" target="_blank">Impressum</a>
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href="https://www.uniklinik-freiburg.de/footernavigation/datenschutz.html" target="_blank">Datenschutz</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
